<template>
  <v-container>
    <v-data-table
      :loading="isLoading"
      :headers="headers"
      :items="employees"
      :items-per-page="5"
      show-expand
      item-key="employee_ID"
      class="elevation-1"
    >
      <template v-slot:item.date_Of_Birth="{ item }">
        {{ formatDate(item.date_Of_Birth) }}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <employeeEmployment :tables="item.employments" />
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  props: ["isLoading", "employees"],
  components: {
    employeeEmployment: () => import("./employeeEmployment.vue")
  },
  data: () => ({
    // tables: [],
    headers: [
      {
        text: "Employee Code",
        value: "employee_ID"
      },
      {
        text: "First Name",
        value: "first_Name"
      },
      {
        text: "Last Name",
        value: "last_Name"
      },
      {
        text: "Date of Birth",
        value: "date_Of_Birth"
      },
      {
        text: "Email",
        value: "email_Home"
      },
      { text: "", value: "data-table-expand" }
    ]
  }),
  created() {},
  methods: {
    formatDate: date => moment(date).format("YYYY-MM-DD")
  },
  watch: {
    employees: {
      handler(val) {
        if (val.length == 0) {
          this.$emit("getEmployees");
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
